// Libraries
import styled from 'styled-components'

export const FormContainer = styled.form``
